import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { isNewWebsitePage } from '../utils/routeOverrides';

const isSSR = typeof window === 'undefined';

/**
 * Check if current page is a new website page
 * @param {object} appStyles - Optional appStyles object with newWebsite.websiteEnabled
 */
const checkIsNewWebsitePage = (appStyles) => {
  if (isSSR) return false;
  const pathname = window.location.pathname;
  // Try to get websiteEnabled from appStyles prop, or fall back to window.pageContext
  const websiteEnabled = appStyles?.newWebsite?.websiteEnabled
    ?? window.pageContext?.business?.appStyles?.newWebsite?.websiteEnabled;
  console.log('checkIsNewWebsitePage websiteEnabled', websiteEnabled);
  return isNewWebsitePage(pathname, websiteEnabled);
};

/**
 * A wrapper around PersistGate that conditionally blocks rendering.
 * - SSR: always render children (no PersistGate blocking)
 * - New website pages: render children immediately (no blocking)
 * - Ordering pages: wait for redux rehydration (normal PersistGate behavior)
 *
 * @param {object} props
 * @param {object} props.persistor - Redux persistor
 * @param {object} props.appStyles - Optional appStyles for more accurate new website detection
 * @param {React.ReactNode} props.children
 */
const SmartPersistGate = ({ persistor, appStyles, children }) => {
  // Check if this is a new website page
  // Will use appStyles prop if provided, otherwise checks window.pageContext
  const isNewWebsite = checkIsNewWebsitePage(appStyles);

  // During SSR or for new website pages, render immediately
  if (isNewWebsite) {
    return children;
  }

  // For ordering pages (client-side only), use normal PersistGate behavior
  return (
    <PersistGate loading={null} persistor={persistor}>
      {children}
    </PersistGate>
  );
};

export default SmartPersistGate;